import React from 'react';

import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsBR } from './addressValidation';
import addressFields from './addressFieldMessages';
import brazilStateMap from './data/BRStateMap';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateSelectField,
    PostalCodeField
} from './Fields';
import postalCodeNormalizerBR from '../validate/postalCodeNormalizarBR';


export const makeStateList = (intl) => {
    const states = Object.keys(brazilStateMap);
    const placeholder = {
        value: '',
        label: intl.formatMessage(addressFields.BR.stateLabel)
    };
    return [placeholder].concat(states.map(code => ({
        value: code,
        label: intl.formatMessage(brazilStateMap[code])
    })));
};


export const AddressFieldsBR = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    useAddressAutocomplete,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.DEFAULT.street1Label,
        updateShippingAddress,
        useAddressAutocomplete,
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.BR.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.DEFAULT.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        label: addressFields.BR.stateLabel,
        options: makeStateList(intl),
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        fieldType: 'tel',
        normalize: postalCodeNormalizerBR,
        label: addressFields.BR.postalCodeLabel,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateSelectField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsBR.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsBR
};

AddressFieldsBR.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsBR;
